import { render, staticRenderFns } from "./WheelOfFortune.vue?vue&type=template&id=42851df1"
import script from "./WheelOfFortune.vue?vue&type=script&lang=js"
export * from "./WheelOfFortune.vue?vue&type=script&lang=js"
import style0 from "./WheelOfFortune.vue?vue&type=style&index=0&id=42851df1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports